import { useAppSelector } from "../app/hooks";
import { IRootState } from "../app/store";

export function useGlobalFetching() {
  return useAppSelector((state: IRootState) => {
    const api = (state as any).api; // <-- ditt reducerPath är "api"
    if (!api) return false;

    const queriesBusy = Object.values(api.queries ?? {}).some(
      // @ts-ignore RTKQ substate
      (q: any) => q?.status === "pending" || q?.isFetching
    );
    const mutationsBusy = Object.values(api.mutations ?? {}).some(
      // @ts-ignore RTKQ substate
      (m: any) => m?.status === "pending"
    );
    return queriesBusy || mutationsBusy;
  });
}